import Attrs from '../models/Attrs'
import renderTemplate from '../helpers/templating'

import type { Component } from '../models/types'
import { addLanguageController } from '../helpers/utils'

export default function renderPlainText(
  component: Component,
  attrs: Attrs,
  editingMode: boolean,
  userData: { [key: string]: unknown }
): string {
  const textAttrs = new Attrs(attrs.static_render)

  //* Add language controller for the text
  addLanguageController({ attrs: textAttrs, component, keys: ['text'] })

  //* Add template controller if the text has {{
  if (component.text && component.text.includes('{{')) {
    textAttrs
      .addController('template')
      .addValueIfExists('template', 'text', encodeURIComponent(component.text || ''))
      .addValueIfExists('template', 'always-rerender', component.always_rerender)
  }

  const text = renderTemplate(component.text, userData)

  return `<div ${attrs}><div ${textAttrs}>${text}</div></div>`
}
